module.exports = __webpack_public_path__ + "afde41c9121a7bf0f68c6570f670f90f.pdf";